/**
 * viewport width --> pixels
 * @param {number} num
 * @returns {number}
 */
export const vwToPx = (num) => (num * window.innerWidth) / 100;

/**
 * pixels --> viewport width
 * @param {number} num
 * @returns {number}
 */
export const pxToVw = (num) => (num * 100) / window.innerWidth;
